
      export default {
        functional: true,
        render(_h, _vm) {
          const { _c, _v, data, children = [] } = _vm;

          const {
            class: classNames,
            staticClass,
            style,
            staticStyle,
            attrs = {},
            ...rest
          } = data;

          return _c(
            'svg',
            {
              class: [classNames,staticClass],
              style: [style,staticStyle],
              attrs: Object.assign({"width":"24","height":"24","xmlns":"http://www.w3.org/2000/svg","preserveAspectRatio":"xMidYMid meet"}, attrs),
              ...rest,
            },
            children.concat([_c('path',{attrs:{"d":"M12 4a8 8 0 100 16 8 8 0 000-16zm1.333 5.591a.833.833 0 110 1.667H10.42a.167.167 0 00-.166.15 6.141 6.141 0 00-.028.592c0 .08 0 .16.004.236.004.09.077.16.167.16h2.117a.833.833 0 110 1.667h-1.52a.167.167 0 00-.133.267c.645.815 1.811 1.167 3.65 1.167a.833.833 0 110 1.666c-1.226 0-4.528-.012-5.6-2.993a.167.167 0 00-.157-.11H8.18a.833.833 0 110-1.667h.22a.168.168 0 00.167-.179 2.816 2.816 0 01-.01-.217c0-.2.01-.382.025-.562a.167.167 0 00-.166-.18h-.207a.833.833 0 010-1.667h.666a.166.166 0 00.152-.099c1.194-2.654 4.306-2.656 5.486-2.656a.833.833 0 010 1.667c-1.534 0-2.596.243-3.282.795a.167.167 0 00.102.296h2z","fill":"#003653","fill-rule":"evenodd"}})])
          )
        }
      }
    